'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (_ref) {
    var _this = this;

    var store = _ref.store,
        layout = _ref.layout,
        el = _ref.el,
        _ref$inputFormat = _ref.inputFormat,
        inputFormat = _ref$inputFormat === undefined ? 'dhis' : _ref$inputFormat,
        _ref$outputFormat = _ref.outputFormat,
        outputFormat = _ref$outputFormat === undefined ? 'highcharts' : _ref$outputFormat,
        extraLayout = _ref.extraLayout,
        extraOptions = _ref.extraOptions,
        onError = _ref.onError,
        onWarning = _ref.onWarning;

    var _validator = _validators2.default[inputFormat] || _validators2.default.noValidation;
    var _adapter = _adapters2.default[inputFormat + '_' + outputFormat];
    var _generator = _generators2.default[outputFormat];

    if (_validator === _validators2.default.noValidation) {
        onWarning('No validation implementation for config input format "' + inputFormat + '"');
    }

    if (!_adapter) {
        onError('No config tranformation implementation for format "' + inputFormat + '" to format "' + outputFormat + '"');
    }

    if (!_generator) {
        onError('No chart implementation for format\xA0' + outputFormat);
    }

    this.getConfig = function () {
        return _adapter({
            layout: _validator({ layout: layout, onError: onError, onWarning: onWarning }),
            extraOptions: _extends({}, DEFAULT_EXTRA_OPTIONS, extraOptions),
            store: store,
            el: el,
            extraLayout: extraLayout
        });
    };

    this.createChart = function () {
        return _generator(_this.getConfig(), el);
    };
};

var _validators = require('./validators');

var _validators2 = _interopRequireDefault(_validators);

var _adapters = require('./adapters');

var _adapters2 = _interopRequireDefault(_adapters);

var _generators = require('./generators');

var _generators2 = _interopRequireDefault(_generators);

var _ = require('..');

var _2 = _interopRequireDefault(_);

var _colors = require('../util/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_EXTRA_OPTIONS = {
    colors: _colors.theme1
};
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/index.js
 ** module id = 219
 ** module chunks = 0 1
 **/